import { ROUTES } from '../types/global/routes.types';
import type { IAdHubPlatformConnection } from '../types/global/adhubConnections.types';

export function adhubBrandHeaders(brandId: string): Record<string, string> {
    return { 'X-AdHub-Brand-Id': brandId };
}

export function getAdHubMetaOAuthRedirectUri(): string {
    return `${window.location.origin}${ROUTES.BRAND_ADHUB_CALLBACK}`;
}

export function normalizeAdAccountId(raw: string): string {
    const trimmed = String(raw || '').trim();
    if (!trimmed) return '';
    if (trimmed.toLowerCase().startsWith('act_')) return trimmed;
    return `act_${trimmed}`;
}

export function findMetaConnection(
    connections: IAdHubPlatformConnection[] | null | undefined,
): IAdHubPlatformConnection | null {
    if (!connections?.length) return null;
    return connections.find(c => String(c.platform).toLowerCase() === 'meta') ?? null;
}

export function isMetaAdHubConnected(connection: IAdHubPlatformConnection | null | undefined): boolean {
    if (!connection || String(connection.platform).toLowerCase() !== 'meta') return false;
    return Boolean(String(connection.platform_account_id || '').trim());
}

export function isMetaAdHubReadyForClientAds(connection: IAdHubPlatformConnection | null | undefined): boolean {
    if (!isMetaAdHubConnected(connection)) return false;
    const pageId = String(connection?.metadata?.facebook_page_id || connection?.metadata?.page_id || '').trim();
    return Boolean(pageId);
}

export function adHubApiErrorMessage(error: any, fallback: string): string {
    return error?.data?.message || error?.data?.error?.message || error?.message || fallback;
}
